<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：客户详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户ID：</span>
              {{ detail.user_id }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16" >
              <div style="float: left;" class="gray9">头像：</div>
              <div>  <el-image style="width: 50px;height: 50px;float: left;" :src="detail.avatarUrl"></el-image></div>
              <div style="clear: both;"></div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">昵称：</span>
                {{ detail.nickName }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">手机号：</span>
                {{ detail.mobile }}
            </div>
          </el-col>
   
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">性别：</span>
              {{ detail.gender==0?"女":"男" }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">注册时间：</span>
              {{ detail.create_time }}
            </div>
          </el-col>

    
        </el-row>
      </div>
      
      <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="备注记录" name="remark"></el-tab-pane>
          <el-tab-pane label="订单记录" name="order"></el-tab-pane>
          <el-tab-pane label="服务记录" name="service"></el-tab-pane>
        </el-tabs>
        <!-- 备注记录 -->

        <div class="product-content"  v-if="activeName == 'remark'">

          <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="备注内容"><el-input size="small" v-model="searchForm.remark" placeholder="请输入备注内容" clearable></el-input></el-form-item>
  
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
    
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit" >查询</el-button></el-form-item>

      </el-form>
    </div>

          <el-button size="small" type="primary" @click="addRemarkClick" :loading="loading">添加备注</el-button>
          <el-form ref="form" :model="form" label-width="100px" style="margin-top: 20px;">
            <div class="table-wrap">
              <el-table size="small" 
             
              :span-method="arraySpanMethoda" :data="tableData" border style="width: 100%" v-loading="loading"  :row-style="getRowStyle">
   
                <el-table-column prop="remark" label="备注" width="100" >
                <template slot-scope="scope">
                  <div class="order-code"   v-if="scope.row.is_top_row"> 
                    <span class="pl16" v-if="scope.row.remark">{{ scope.row.remark }}</span>
                  </div>
    
                 </template>
  
          </el-table-column>

          <el-table-column prop="user_remark_id" label="ID" >
                  <template slot-scope="scope"   v-if="!scope.row.is_top_row">
                    <div class="order-code" > 
                      <span class="pl16" >{{ scope.row.user_remark_id }}</span>
                    </div>
        
                  </template>
            </el-table-column>  

                <el-table-column prop="name" label="照片" width="200">
                    <template  slot-scope="scope"  v-if="!scope.row.is_top_row && scope.row.images">
                      <div style="height: 80px;width:210px; overflow-x:auto;">
                        <div v-for="(item,index) in scope.row.images" :key="index" style="float: left;">
                          <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                          ref="preview" :preview-src-list="scope.row.images_arr"
                          ></el-image>
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                      
                      
                    </template>

                </el-table-column>
                <el-table-column prop="opuser.nickName" label="前端最后编辑人员"></el-table-column>
                <el-table-column  label="后端最终编辑人员" >
                  <template slot-scope="scope"  v-if="!scope.row.is_top_row">
                    <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                    <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                    </div>
                  </template>

                </el-table-column>
                
                
                <!-- <el-table-column prop="status" label="状态"></el-table-column> -->
                <el-table-column prop="sort" label="排序"></el-table-column>
            

      
                <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
                <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>
                
                <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.app_id !=1">
               <el-button @click="editRemarkClick(scope.row)" type="text" size="small">编辑</el-button>
               <el-button @click="delRemarkClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
                
              </el-table>
            </div>
          </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>


      <AddRemark :open_add="is_remark_add" v-if="is_remark_add" :user_id="detail.user_id"   @close="closeAddRemark"></AddRemark>
      <EditRemark :open_add="is_remark_edit"  :user_remark_id="user_remark_id"  v-if="is_remark_edit"   @close="closeEditRemark"></EditRemark>
    </div>
      <!-- 订单信息 -->
      <div class="product-content" style="margin-top: 20px;" v-if="activeName == 'order'">
        <div class="common-seach-wrap">
          <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号" clearable></el-input></el-form-item>
      
            <el-form-item label="起始时间">
              <div class="block">
                <span class="demonstration"></span>
                <el-date-picker
                  size="small"
                  v-model="searchForm.create_time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
            </el-form-item>
        
            <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>

          </el-form>
        </div>

      <div class="table-wrap">
      
        <el-table size="small" :data="tableData" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column type="selection"></el-table-column> -->
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
                <span class="pl16" v-if="scope.row.remark">后台备注：{{ scope.row.remark }}</span>
              </div>
              <template v-else>
                  <div class="product-info" v-for="(item, index) in scope.row.product" :key="index" 
                   >
                  <div class="pic"><img v-img-url="item.image?item.image.file_path:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="直推用户">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.referee">{{ scope.row.referee?scope.row.referee.nickName:'' }}</div>
              <div class="gray9"  v-if="scope.row.referee">ID：({{ scope.row.referee? scope.row.referee.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user?scope.row.user.mobile:''}}</span>
              <br />
              <span v-if="scope.row.reserve_date||scope.row.reserve_time">预约时间:{{scope.row.reserve_date?scope.row.reserve_date:''}} {{scope.row.reserve_time?scope.row.reserve_time:''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column prop="logistics" label="发货仓库" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics">{{ scope.row.logistics.name }}({{ scope.row.logistics.logistics_id }})</span>
              <span v-else>平台</span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_log_status" label="佣金状态" width="80" align="center">
            <template slot-scope="scope" v-if="scope.row.is_agent">
              <span v-if="scope.row.agent_log_status == 20" class="green">已结算</span>
              <span v-else-if="scope.row.agent_log_status == 10">未结算</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="is_import" label="后台导入" width="80" align="center">
            <template slot-scope="scope" v-if="scope.row.is_import">
              <span v-if="scope.row.is_import">是</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
               <!-- <el-button @click="serviceClick(scope.row)" type="text" size="small">服务项目</el-button> -->
               <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>




    <div class="product-content"  v-if="activeName == 'service'">

        <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="服务记录"><el-input size="small" v-model="searchForm.remark" placeholder="请输入服务记录" clearable></el-input></el-form-item>

        <el-form-item label="起始时间">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            size="small"
            v-model="searchForm.create_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit" >查询</el-button></el-form-item>

        </el-form>
        </div>

        <el-button size="small" type="primary" @click="addServiceClick" :loading="loading">添加服务记录</el-button>
        <el-form ref="form" :model="form" label-width="100px" style="margin-top: 20px;">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
              <el-table-column prop="remark" label="服务标题"></el-table-column>
              <el-table-column prop="name" label="服务单照片" width="200">
                  <template  slot-scope="scope">
                    <div style="height: 80px;width:210px; overflow-x:auto;">
                      <div v-for="(item,index) in scope.row.images" :key="index" style="float: left;">
                        <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                        ref="preview" :preview-src-list="scope.row.images_arr"
                        ></el-image>
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    
                    
                  </template>

              </el-table-column>
              <el-table-column prop="name" label="术前照片" width="200">
                  <template  slot-scope="scope">
                    <div style="height: 80px;width:210px; overflow-x:auto;">
                      <div v-for="(item,index) in scope.row.pre_images" :key="index" style="float: left;">
                        <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                        ref="preview" :preview-src-list="scope.row.pre_images_arr"
                        ></el-image>
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    
                    
                  </template>

              </el-table-column>
              <el-table-column prop="name" label="术后照片" width="200">
                  <template  slot-scope="scope">
                    <div style="height: 80px;width:210px; overflow-x:auto;">
                      <div v-for="(item,index) in scope.row.after_images" :key="index" style="float: left;">
                        <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                        ref="preview" :preview-src-list="scope.row.after_images_arr"
                        ></el-image>
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    
                    
                  </template>

              </el-table-column>
              <el-table-column prop="opuser.nickName" label="前端最后编辑人员"></el-table-column>
              <el-table-column  label="后端最终编辑人员">
                <template slot-scope="scope">
                  <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                  <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                  </div>
                </template>

              </el-table-column>
              
              
              <!-- <el-table-column prop="status" label="状态"></el-table-column> -->
           


              <el-table-column prop="create_time" label="日期" width="150"></el-table-column>
              <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>
              
              <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <el-button @click="editServiceClick(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="delServiceClick(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
              
            </el-table>
          </div>
        </el-form>
            <!--分页-->
            <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
            ></el-pagination>
            </div>


        <AddService :open_add="is_service_add" v-if="is_service_add" :user_id="detail.user_id"   @close="closeAddService"></AddService>
        <EditService :open_add="is_service_edit"  :user_service_id="user_service_id"  v-if="is_service_edit"   @close="closeEditService"></EditService>
        </div>

  

 </div>

  

  

    <div class="common-button-wrapper" >
      <el-button size="small" type="info" @click="cancelFunc" v-if="!this.user_id">返回上一页</el-button>
    

    </div>

    <!--选择用户-->
    <deliveryUser :storeId="Number(form.store_id)" :is_open="isOpenGetUser" :multi="false" @close="closeGetUserFunc"></deliveryUser>
 
    <Service :open_edit="is_service" :order_id="order_id" v-if="is_service" @close="closeServiceFunc"></Service>

   </div>
</template>

<script>
  import UserApi from '@/api/user.js';
   import Service from './dialog/service.vue'
   import clip from '@/utils/clipboard'
  import deliveryUser from '@/components/user/deliveryUser';

  import AddRemark from './remark/part/add.vue';
  import EditRemark from './remark/part/edit.vue';

  import AddService from './service/part/add.vue';
  import EditService from './service/part/edit.vue';
  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {
 
      deliveryUser,
      Service,
      // ServiceRemark,
      AddRemark,
      EditRemark,
      
      AddService,
      EditService,
    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: [],
          delivery_warehouse: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          is_cancel: 1
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_edit: false,
        supply_id:0,
        // 选择用户flag
        isOpenGetUser: false,
        // 选择的配送员列表,只有一个
        select_list: [],
        deliveryForm: {

        },
        serviceData:[],
        is_service:false,
        is_service_remark:false,

        tableData:[],
         /*切换菜单*/
        activeName: 'remark',
         /*统计*/
        order_count: {
          payment: 0,
          delivery: 0,
          received: 0
        },
         /*一页多少条*/
         pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,

        searchForm: {
          order_no:"",
          create_time:""
        },
        order_id:0,
        is_service:false,

        is_remark_add:false,
        is_remark_edit:false,
        user_remark_id:0,

        is_service_add:false,
        is_service_edit:false,
        user_service_id:0,
      };
    },
    props: ['user_id'],
    created() {
      this.activeName = this.$route.query.activeName
      /*获取列表*/
      this.getData();
    },
    watch: {
      activeName: function(n, o) {
        if (n != o) {
          this.dialogVisible = n;
          if (n) {
            this.curPage = 1;
           this.pageSize = 20;
            this.getData();
          }
        }
      }
    },  
    methods: {
      addRemarkClick(){//添加备注
        this.is_remark_add = true;
      },
      editRemarkClick(row){//修改备注
        this.user_remark_id = row.user_remark_id
        this.is_remark_edit = true;
      },
      /*关闭添加*/
      closeAddRemark(e){
        this.is_remark_add=false;
        this.getData();
      },
      closeEditRemark(e){
        this.is_remark_edit=false;
        this.getData();
      },
          /*删除*/
          delRemarkClick (row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            UserApi.del_remark(
              {
                user_remark_id: row.user_remark_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getData();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },



      addServiceClick(){//添加备注
        this.is_service_add = true;
      },
      editServiceClick(row){//修改备注
        this.user_service_id = row.user_service_id
        this.is_service_edit = true;
      },
      /*关闭添加*/
      closeAddService(e){
        this.is_service_add=false;
        this.getData();
      },
      closeEditService(e){
        this.is_service_edit=false;
        this.getData();
      },
          /*删除*/
          delServiceClick (row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            UserApi.del_service(
              {
                user_service_id: row.user_service_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getData();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },

      

        handleCopy(text, event) {
        clip(text, event)
      },
      detailClick(e){//订单详情
        let self = this;
        let params = e.order_id;
        self.$router.push({
          path: '/order/order/Detail',
          query: {
            order_id: params
          }
        });
      },
      serviceClick(e){
        this.order_id = e.order_id;
        this.is_service = true;
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

       /*切换菜单*/
      handleClick(tab, event) {
        this.totalDataNumber = 0;
         this.tableData  = [];
        this.$router.push({
          path: '/user/user/detail',
          query: {
            user_id: this.$route.query.user_id,
            activeName:this.activeName
          }
        });
      },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    arraySpanMethoda(row) {
      if (row.rowIndex % 3 == 0) {
        if (row.columnIndex === 0) {
          return [1, 6];
        }
      }
    },
      getRowStyle(row, index) {
        let styleJson = {}     
       if (row.show) {
            styleJson = {
                'background': '#999999'
            }
       } else {
            styleJson = {
                'background': '#ffffff'
            }
       }
       return styleJson  // 返回对象
    },
      addService(){
        this.is_service = true;
      },
      addRemark(order_service_id){
        this.order_service_id = order_service_id;
        this.is_service_remark = true;
       
      },
      flush(){
        this.getData();
      },

      next() {
        if (this.active++ > 4) this.active = 0;
      },
          /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
      /*获取参数*/
      getData() {
        let self = this;
        // 取到路由带过来的参数
        var Params = this.searchForm;
        Params.page = self.curPage;
        Params.user_id =  this.user_id ? this.user_id : this.$route.query.user_id
        Params.list_rows = self.pageSize;
        Params.activeName = self.activeName
        Params.XDEBUG_SESSION_START = 'PHPSTORM'
        UserApi.detail(Params ).then(data => {
          self.loading = false;
          self.detail = data.data.detail;
          if(self.activeName == 'order'){
            self.totalDataNumber = data.data.tableData.total;
            var list = [];
            for (let i = 0; i < data.data.tableData.data.length; i++) {
              let item =  data.data.tableData.data[i];
              let topitem = {
                order_no: item.order_no,
                create_time: item.create_time,
                order_source:item.order_source,
                order_source_text:item.order_source_text,
                is_top_row: true,
                remark: item.remark
              };
              list.push(topitem);
              list.push(item);
            }
            console.log("list",list)
            self.tableData = list;
          }else if(self.activeName == 'remark'){
            self.totalDataNumber = data.data.tableData.total;
      

            let list = [];
            for (let i = 0; i < data.data.tableData.data.length; i++) {
              let item = data.data.tableData.data[i];
              let topitem = {
                is_top_row: true,
                images: item.images,
                remark: item.remark
              };
              list.push(topitem);
              list.push(item);
            }
            console.log("list",list)
            var new_list = [];
            for(var i=0;i<list.length;i++){
              new_list.push(list[i]);
              if(i!=0){
                if(list[i].app_id){
                  new_list.push({
                    is_top_row: false,
                    remark: "",
                    app_id:1
                  });
                }
               
              }
            }
            console.log("new_list",new_list)
            self.tableData = new_list;



          }else if(self.activeName == 'service'){
            self.totalDataNumber = data.data.tableData.total;
            self.tableData =  data.data.tableData.data;
          }
          
        })
          .catch(error => {
            self.loading = false;
          });
      },


      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getData();
        }
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开获取用户*/
      openGetUser() {
        this.isOpenGetUser = true
      },
      /*关闭获取用户*/
      closeGetUserFunc(e) {
        if (e.type != 'error') {
          this.select_list = [e.params]
        }
        this.isOpenGetUser = false
      },
      closeServiceFunc(e){
        if (e.type != 'error') {
  
          this.getData();
        }
        this.is_service = false
        this.is_service_remark = false
      },
  

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/detail.vue